// extracted by mini-css-extract-plugin
export var active = "_df-7";
export var container = "_df-0";
export var evenWidth = "_df-4";
export var large = "_df-5";
export var outlet = "_df-8";
export var slide = "_df-2";
export var small = "_df-6";
export var tab = "_df-3";
export var tabs = "_df-1";